// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiSelector_iEswt {
  display: flex;
  flex-direction: horizontal;
  flex-wrap: wrap;
  gap: 8px;
}

.multiSelectorItemLabel_A0W7S {
  flex: 1;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.multiSelectorItemRemove_wFiNp {
  flex: 1;
  flex-grow: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/components/MultiSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd","sourcesContent":[".multiSelector {\n  display: flex;\n  flex-direction: horizontal;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.multiSelectorItemLabel {\n  flex: 1;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.multiSelectorItemRemove {\n  flex: 1;\n  flex-grow: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelector": `multiSelector_iEswt`,
	"multiSelectorItemLabel": `multiSelectorItemLabel_A0W7S`,
	"multiSelectorItemRemove": `multiSelectorItemRemove_wFiNp`
};
export default ___CSS_LOADER_EXPORT___;
